import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: any) => ({
  box: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  boxText: {
    fontFamily: "Poppins",
    fontWeight: 800,
    color: "#4D1277",
    fontSize: "24px",
    letterSpacing: "-0.6px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  countBadge: {
    backgroundColor: "#4D127712",
    color: "#4D1277",
    padding: "2px 10px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 700,
    fontFamily: "Poppins",
    marginLeft: "12px",
    display: "flex",
    alignItems: "center",
  },
  headerTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    margin: "12px 0 16px 0",
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 10,
    paddingBottom: "16px",
    borderBottom: "1px solid #f0f0f0",
    marginBottom: "20px",
  },
  heading: {
    width: "100%",
    fontWeight: "500",
    fontFamily: "poppins",
    fontSize: "16px",
    color: "#272525",
  },
  labelAddButton: {
    borderRadius: "10px",
    background: "#4D1277",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "14px",
    color: "#fff",
    height: "44px",
    padding: "0 24px",
    boxShadow: "0 4px 12px rgba(77, 18, 119, 0.15)",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "#3a0d5a",
      transform: "translateY(-1px)",
      boxShadow: "0 6px 16px rgba(77, 18, 119, 0.25)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  watchVideoBtn: {
    color: "#4D1277",
    fontWeight: 700,
    fontFamily: "Poppins",
    fontSize: "14px",
    textTransform: "none",
    padding: "8px 16px",
    borderRadius: "12px",
    "&:hover": {
      backgroundColor: "#4D127708",
    },
    "& .MuiButton-startIcon": {
      color: "#FF0000",
    },
  },
  labelAddIcon: {
    color: "white",
    fontSize: "20px",
  },
  modalIcon: {
    height: "50px",
    width: "50px",
  },
  infoBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "12px 0",
    gap: "24px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      gap: "12px",
      margin: "15px 0",
    },
  },
  infoText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  square: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    marginRight: "4px",
  },
  backgroundPersonal: {
    backgroundColor: "#1877F2",
  },
  backgroundGeneric: {
    backgroundColor: "#FF5A5F",
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "12px",
    color: "#95a5a6",
    letterSpacing: "0.2px",
    textTransform: "uppercase",
  },
  fieldStyle: {
    color: "#2d3436",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Poppins",
    width: "100%",
    backgroundColor: "transparent !important", // Inherit from parent bar
    "& fieldset": { border: "none" },
    "& input": {
      padding: "8px 0",
    },
  },
  searchBoxClass: {
    height: "44px",
    width: "100%",
    maxWidth: "500px",
    backgroundColor: "#f5f6f7 !important", // Soft background for the bar
    borderRadius: "10px !important",
    border: "1px solid #e0e0e0 !important",
    boxShadow: "none !important",
    padding: "0 16px !important",
    transition: "all 0.2s ease !important",
    "&:hover": {
      borderColor: "#d1d1d1 !important",
      backgroundColor: "#f1f3f5 !important",
    },
    "&:focus-within": {
      backgroundColor: "#fff !important",
      borderColor: "#4D1277 !important",
      boxShadow: "0 4px 12px rgba(77, 18, 119, 0.08) !important",
    },
    "& .MuiInputBase-root": {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  },
  cardContent: {
    padding: 0,
    margin: 0,
    paddingBottom: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  typography: {
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#838383",
    marginTop: "5px",
  },
  box2: {
    marginTop: "20px",
    marginLeft: "20px",
  },
  headerText: {
    fontWeight: "500",
    fontSize: "16px",
    LineHeight: "24px",
    padding: "0px",
  },
  subHeading: {
    fontWeight: "400",
    fontSize: "14px",
    marginTop: 10,
    LineHeight: "21px",
    color: "#838383",
  },
  button: {
    backgroundColor: "#4D1277",
    borderRadius: "3px",
    fontFamily: "poppins",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#FFFFFF",
    textTransform: "capitalize",
    boxShadow: "none",
    marginTop: "37px",
  },
  addIcon: {
    fontSize: "18px",
  },
  span: { textTransform: "capitalize", fontSize: 14 },
  loadingCircularProgress: {
    margin: "auto",
    display: "block",
    marginTop: 20,
    color: "#55A530",
  },
  countBoxTop: {
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
  },
  countBox: {
    padding: "8px 10px",
    backgroundColor: "#EAE9E9",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 8px",
      fontSize: "14px",
    },
  },
  countBoxTypo: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#272525",
    textTransform: "lowercase",
  },
  bottomBox: {
    padding: 0,
  },
  root: {
    paddingBottom: 0,
    overflowY: "auto",
    paddingRight: "10px",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#4d127733",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    height: "calc(100vh - 170px)",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 200px)",
    },
    [theme.breakpoints.down("xmd")]: {
      height: "calc(100vh - 210px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 260px)",
      paddingRight: "0",
    },
  },
  noCountBox: {
    fontFamily: "poppins",
    fontSize: "16px",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
  cannedMain: {
    width: "70%",
    marginTop: "20px",
    padding: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  whatAreHeading: {
    fontFamily: "poppins",
    fontSize: "14px",
    padding: "5px 0px",
    borderBottom: "1px solid rgba(119, 119, 119,.5)",
  },
  whatArePara: {
    fontFamily: "poppins",
    fontSize: "12px",
    color: "rgba(119, 119, 119,1)",
    marginBottom: "30px",
  },
  addCannedResponseMain: {
    width: "80%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  addCannedResponseShortcutMain: {
    display: "grid",
    gridTemplateColumns: "65% auto",
    gridGap: "7px",
    marginBottom: "5px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100%",
    },
  },
  addCannedResponseShortcutInput: {
    fontFamily: "poppins",
    fontSize: "12px",
    color: "#777777",
    border: "1px solid rgba(119,119,119,.5)",
    borderRadius: "3px",
    paddingLeft: "5px",
  },
  addCannedResponseShortcutBtn: {
    border: "none",
    borderRadius: "3px",
    color: "white",
    background: "#55A530",
    fontFamily: "poppins",
    fontSize: "12px",
    padding: "6px 15px",
    cursor: "pointer",
  },
  addCannedResponseMainLong: {
    display: "grid",
    gridTemplateColumns: "65%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100%",
    },
  },
  addCannedResponseLongInput: {
    fontFamily: "poppins",
    fontSize: "12px",
    color: "#777777",
    border: "1px solid rgba(119,119,119,.5)",
    borderRadius: "3px",
    paddingLeft: "5px",
  },
  addCannedResponseLongPara: {
    marginTop: "10px",
    fontFamily: "poppins",
    fontSize: "11.5px",
    color: "#777777",
  },
  addCannedResponseListSearch: {
    display: "flex",

    paddingBottom: "20px",
    borderBottom: "1px solid rgba(119,119,119,.5)",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "10px",
    },
  },
  addCannedResponseListSearchInput: {
    fontFamily: "poppins",
    fontSize: "12px",
    color: "#777777",
    border: "1px solid rgba(119,119,119,.5)",
    borderRadius: "3px",
    paddingLeft: "5px",
    width: "200px",
    height: "29px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  addCannedResponseListItemMain: {
    padding: "15px 0px 10px 0",
    borderBottom: "1px solid rgba(119,119,119,.5)",
  },
  addCannedResponseListItemLongText: {
    color: "black",
    fontSize: "13.5px",
    fontFamily: "poppins",
    fontWeight: "500",
    marginBottom: "5px",
  },
  addCannedResponseListItemShortTextMain: {
    fontFamily: "poppins",
    fontSize: "12px",
    color: "#777777",
  },
  addCannedResponseListItemShortText: {
    marginLeft: "5px",
    border: "1px solid rgba(119,119,119,.5)",
    padding: "1px 6px",
    fontSize: "12px",
    color: "black",
  },
  addCannedResponseListItemBtnMain: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
    marginTop: "-25px",
  },
  addCannedResponseListItemBtnEdit: {
    border: "none",
    background: "none",
    fontFamily: "poppins",
    fontSize: "13px",
    color: "green",
  },
  addCannedResponseListItemBtnDelete: {
    border: "none",
    background: "none",
    fontFamily: "poppins",
    fontSize: "13px",
    color: "red",
  },
  focusRemove: {
    width: "160px",
    height: "30px",
    fontFamily: "poppins",
    fontSize: "13px",
    marginLeft: "10px",
    outline: "none",
    boxShadow: "none !important",
  },
  displayNone: {
    display: "none",
  },
}));

export default useStyles;
